import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

const HERO_BG = "linear-gradient(135deg, #2B0D2E 0%, #6A1B9A 100%)";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Bem-vinda(o) ao Banco das Revendedoras");
      nav("/");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-hero grain" style={{ background: HERO_BG }}>
        <div>
          <img src="/logo-full.png" alt="Banco das Revendedoras - Cris Lingerie" className="w-40 rounded-2xl shadow-lg" />
        </div>
        <div className="max-w-md">
          <h1 className="font-display text-5xl font-bold leading-[1.05] tracking-tight">
            Credito inteligente para sua carteira de clientes.
          </h1>
          <p className="text-sm mt-5 opacity-85 leading-relaxed">
            Score interno, promissoria digital, cobranca automatizada e o controle financeiro
            que sua revenda merece.
          </p>
          <div className="flex gap-3 mt-8 text-[10px] tracking-[0.2em] uppercase opacity-70">
            <span>Score 0-1000</span><span>·</span><span>Antifraude</span><span>·</span><span>PDF Legal</span>
          </div>
        </div>
      </div>

      <div className="login-form-wrap">
        <div className="login-card">
          <div className="min-[900px]:hidden mb-8">
            <img src="/logo-full.png" alt="Banco das Revendedoras - Cris Lingerie" className="w-28 rounded-2xl shadow-md" />
          </div>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#7A6A78] mb-3">Acesso</div>
          <h2 className="font-display text-4xl font-bold tracking-tight">Entre na sua conta</h2>
          <p className="text-sm text-[#5C5A57] mt-2 mb-10">Administradores, revendedoras e clientes.</p>

          <form onSubmit={submit} className="flex flex-col gap-6">
            <div>
              <label className="block text-[10px] tracking-[0.18em] uppercase text-[#5C5A57] mb-2">E-mail</label>
              <input
                data-testid="login-email-input"
                type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-underline"
                placeholder="voce@crislingerie.com"
              />
            </div>
            <div>
              <label className="block text-[10px] tracking-[0.18em] uppercase text-[#5C5A57] mb-2">Senha</label>
              <input
                data-testid="login-password-input"
                type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-underline"
                placeholder="********"
              />
            </div>

            <button data-testid="login-submit-button" type="submit" className="brand mt-2" disabled={loading}>
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>

          <div className="mt-8 text-xs text-[#5C5A57]">
            Esqueceu a senha? Entre em contato com o administrador do sistema.
          </div>
        </div>
      </div>
    </div>
  );
}
